export function tableConfig(selectPersonClick, getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: true,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    // index: true,
    // indexLabel: "序号",
    searchShow: false,
    selection: true,
    selectionWidth: 45,
    // showSummary: true,
    // sumColumnList: [{
    //   name: "factoringCredit",
    //   overHidden: true,
    //   type: "sum",
    // }],
    column: [


      {
        label: "搜索查询",
        searchPlaceholder: "合同编号/合同名称/联系信息",
        placeholder: "合同编号/合同名称/联系信息",
        prop: "search",
        hide: true,
        display: true,
        search: true,
        hideshow: true,
      },

      {
        sortable: "custom",
        label: "合同编号",
        prop: "contractNo",
        width: "120",
        display: false,
        overHidden: true,
      },
      {
        label: "合同名称",
        prop: "contractName",
        width: "220",
        display: false,
        overHidden: true,
        slot: true

      },
      {
        label: "客户名称",
        prop: "custId",
        width: "160",
        type: "select",
        filterable: "true",
        dicUrl: "/api/blade-/zd/custom/getListDefault",
        dicMethod: "post",
        dicQuery: {},
        props: {
          label: "custName",
          value: "id",
        },
        dataType: "string",
        search: true,
        hide: true,
        hideshow: true,
      },

      {
        label: "用印文件",
        prop: "file",
        slot: true,
        width: "180",
        display: false,
        overHidden: true,

      },
      {
        label: "合同状态",
        prop: "auditStatus",
        width: "100",
        type: "select",
        display: false,
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=zd_audit_status",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
        overHidden: true,
        search: true,
        // hide: true,
        // hideshow: true,

      },
      // {
      //   label: "合同状态",
      //   prop: "auditStatusStr",
      //   width: 160,
      //   display: false,
      //   overHidden: true,
      //   search: false,
      //   formatter: (row, value, label, column) => {
      //     let name = ""
      //     if (row.auditStatus == 2&&row.auditStatusStop == 2) {
      //       name ='合同终止'

      //     } else {
      //       name = row.auditStatusStr
      //     }

      //     return name

      //   },
      // },
      {
        label: "合同金额",
        sortable: "custom",
        prop: "quota",
        width: "120",
        formslot: true,
        overHidden: true,
        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return getMoney(value);
          }
        },
      },
      {
        label: "申请银行",
        prop: "bankName",
        width: 160,
        display: false,
        overHidden: true,
      },
      {
        label: "申请银行",
        prop: "bankId",
        hide: true,
        width: "160",
        type: "select",
        filterable: "true",
        dicUrl: "/api/blade-/zd/bank/getListDefault",
        dicMethod: "post",
        dicQuery: {
          type: 0,
        },
        props: {
          label: "bankName",
          value: "id",
        },
        dataType: "string",
        hideshow: true,
      },
      {
        label: "使用天数",
        prop: "expectUseDay",
        formslot: true,
        width: "80",
      },
      {
        label: "使用费率",
        prop: "loanRate",
        width: "80",
        type: "select",
        dicUrl: "/api/blade-/zd/interestrate/dictionary",
        dicMethod: "get",
        dicQuery: {},
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
        display: true,
      },
      {
        label: "预计出款日期",
        prop: "expectPayDate",
        width: "120",
        type: "data",
        display: false,

      },
      {
        label: "预计出款日期",
        prop: "expectPayDate1",
        type: "daterange",
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
        startPlaceholder: "开始",
        endPlaceholder: "结束",
        hide: true,
        display: true,
        search: false,
        hideshow: true,
      },
      {
        label: "客户经理",
        prop: "managerName",
        display: false,
      },
      {
        label: "客户经理",
        prop: "managerUserName",
        readonly: true,
        search: true,
        clearable: false,
        display: true,
        hide: true,
        hideshow: true,
        click: () => {
          selectPersonClick();
        },
      },
    ]
  }
}





export function myTableConfig(selectPersonClick, getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: false,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    selection: true,
    selectionWidth: 45,
    column: [



      {
        label: "合同名称",
        prop: "contractName",
        // width: "180",
        overHidden: true,
      },

      {

        label: "合同编号",
        prop: "contractNo",
        width: "120",
        overHidden: true,
      },

      {
        label: "合同金额",

        prop: "quota",
        width: "160",
        formslot: true,
        overHidden: true,
        formatter: (row, value, label, column) => {
          if (value == -1) {
            return "-";
          } else {
            return getMoney(value);
          }
        },
      },
      {
        label: "申请银行",
        prop: "bankName",
        width: 160,
        display: false,
        overHidden: true,
      },

      {
        label: "使用天数",
        prop: "expectUseDay",
        formslot: true,
        width: 120,
      },
      {
        label: "使用费率",
        prop: "loanRate",
        width: "80",
        type: "select",
        dicUrl: "/api/blade-/zd/interestrate/dictionary",
        dicMethod: "get",
        dicQuery: {},
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
        display: true,
      },
      {
        label: "预计出款日期",
        prop: "expectPayDate",
        width: "120",
        type: "data",
        display: false,

      },


    ]
  }
}
export function contractAddFormConfig(getMoney) {
  return {
    labelWidth: 130,
    emptyBtn: false,
    submitBtn: false,
    column: [

      {
        label: "所属项目",
        prop: "projectName",
        disabled: true,
        placeholder: "-",
        span: 12,
      }, {
        label: "预计出款时间",
        prop: "expectPayDate",
        disabled: false,
        slot: false,
        typeState: "date",
        readonly: true,
        placeholder: "-",
        span: 12,
        type: "date",
        clearable: false,
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
      },
      {
        label: "客户名称",
        prop: "custName",
        mock: {
          type: "name",
        },
        disabled: true,
        placeholder: "-",
        span: 12,
      },
      {
        label: "合同编号",
        prop: "contractNo",
        slot: false,
        type: 'input',
        disabled: true,
        placeholder: "等待综合管理部填写",
        span: 12,
      },
      {
        label: "申请银行",
        prop: "bankName",
        disabled: true,
        placeholder: "-",
        span: 12,
      },
      {
        label: "客户经理",
        prop: "managerName",
        disabled: true,
        placeholder: "-",
        span: 12,
      },
      {
        label: "合同金额",
        prop: "quota",
        disabled: true,
        placeholder: "-",
        span: 12,
        formatter: (row, value, label, column) => {
          return `${getMoney(Number(value).toFixed(2))}元`;
        },
      },
      {
        label: "使用天数",
        prop: "expectUseDay",
        disabled: true,
        placeholder: "-",
        span: 12,
        unit: '天'
      },

      {
        label: "使用费率",
        prop: "loanRate",
        disabled: true,
        placeholder: "-",
        span: 12,
        formatter: (row, value, label, column) => {
          return value * 100 + "%";
        },
      },



    ]
  }
}

export function releaseConfig(getMoney) {
  return {
    // searchIndex:3,
    searchIcon: true,
    addBtn: false,
    delBtn: false,
    columnBtn: false,
    refreshBtn: false,
    editBtn: false,
    menu: false,
    align: "center",
    column: [{
        label: "投放名称",
        prop: "placementTitle",
        width: "350",
      },
      {
        label: "合同金额",
        prop: "amtPlacement",
        formatter: (row, value, label, column) => {
          return getMoney(value) + "元";
        },
      },
      {
        label: "项目投放",
        prop: "id",
        slot: true,
      },
      {
        label: "回款状态",
        prop: "text4",
      },
    ],
  }
}
export function detailTableCustomConfig(getMoney) {
  return {
    menuWidth: 120,
    detailBtn: true,
    editBtn: false,
    delBtn: false,
    detailAddBtn: false,
    addBtn: false,
    index: true,
    indexLabel: "序号",
    align: 'center',
    readonly: false,
    isButton: true,
    column: [

      {
        label: "客户名称",
        prop: "custName",
        width: 200

      },
      {
        label: "申请银行",
        prop: "bankName",

      },

      {
        label: "合同金额",
        prop: "quota",
        formatter: (row, value, label, column) => {

          return `${getMoney(value)}`;
        },
        width: 100
      },
      {
        label: "预计出款时间",
        prop: "expectPayDate",
        width: 120
      },
      {
        label: "预计使用天数",
        prop: "expectUseDay",
        width: 120
      },
      {
        label: "使用费率",
        prop: "loanRate",

        width: 100,
        formatter: (row, value, label, column) => {
          return value * 100 + "%/天";
        },
      },
    ],
  }

}
